import { useEffect, useState } from 'react'
import classnames from 'classnames'
import CircleLoader from '@components/CircleLoader'
import TableCell from '@components/TableCell'
import TableRow from '@components/Table/TableRow'
import Button from '@components/Button'
import IconButton from '@components/IconButton'

import PaymentModal from 'dashboard-subscriptions/components/PaymentModal'
import SubscriptionModalFooter from 'dashboard-subscriptions/components/SubscriptionModalFooter'

import { clearPending } from 'api/actions'
import { getSubscriptionInvoices, downloadInvoice } from 'dashboard-subscriptions/actions'
import { subscriptionInvoicesLoadingSelector, subscriptionInvoicesSelector } from 'dashboard-subscriptions/selectors'
import { INVOICE_PAYMENT_PROGRESS } from 'dashboard-subscriptions/constants'
import InvoicesHeader from 'dashboard-subscriptions/components/InvoicesTab/InvoicesHeader'

import styles from '../styles.module.scss'

const InvoicesTab = ({
    subscriptionInvoices,
    subscriptionId,
    subscriptionsLoading,
    getSubscriptionInvoices,
    closeModal,
    downloadInvoice,
    isActiveSubscription,
    clearPending,
    paidWithPad,
}) => {
    const [selectedInvoice, setSelectedInvoice] = useState(null)
    useEffect(() => {
        getSubscriptionInvoices(subscriptionId)
    }, [])

    const closePaymentModal = () => {
        clearPending([INVOICE_PAYMENT_PROGRESS])
        setSelectedInvoice(null)
    }

    return (
        <>
            {selectedInvoice !== null && (
                <PaymentModal
                    subscriptionId={subscriptionId}
                    invoice={subscriptionInvoices[selectedInvoice]}
                    closeModal={closePaymentModal}
                />
            )}
            <div className={styles.invoicesTable}>
                <div className={classnames('table', 'table-hover')}>
                    <InvoicesHeader isInvoicesTab />
                    {subscriptionsLoading ? (
                        <div className="d-flex justify-content-center mt-4 pb-4">
                            <CircleLoader size="medium" />
                        </div>
                    ) : (
                        subscriptionInvoices.map((invoice, index) => (
                            <TableRow key={index} className={classnames(styles.invoiceRow)}>
                                <TableCell
                                    className={styles.invoice}
                                    fieldName={<T>dashboard.subscriptions.invoices.invoice</T>}
                                    titleClassName="smallTableHeader">
                                    <div
                                        onClick={() => downloadInvoice(invoice.id)}
                                        className="d-flex align-items-center ml-0"
                                        role="button">
                                        <IconButton icon="download" />
                                        {invoice.invoiceNumber}
                                    </div>
                                </TableCell>
                                <TableCell
                                    fieldName={<T>dashboard.subscriptions.invoices.due.date</T>}
                                    titleClassName="smallTableHeader">
                                    {invoice.dueDate}
                                </TableCell>
                                <TableCell
                                    className={classnames(styles.amount, {
                                        [styles.active]: invoice.balance !== '0' && isActiveSubscription,
                                    })}
                                    fieldName={<T>dashboard.subscriptions.invoices.amount</T>}
                                    titleClassName="smallTableHeader">
                                    ${invoice.amount}
                                </TableCell>
                                <TableCell
                                    fieldName={<T>dashboard.subscriptions.invoices.status</T>}
                                    titleClassName="smallTableHeader">
                                    {paidWithPad && invoice.balance > '0' ? (
                                        <T>dashboard.subscriptions.invoices.status.to.be.paid</T>
                                    ) : invoice.balance === '0' ? (
                                        <T>dashboard.subscriptions.invoices.status.paid</T>
                                    ) : (
                                        <Button
                                            size="small"
                                            className={styles.payBtn}
                                            onClick={() => setSelectedInvoice(index)}>
                                            <T>dashboard.subscriptions.pay</T>
                                        </Button>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </div>
            </div>
            <SubscriptionModalFooter closeModal={closeModal} />
        </>
    )
}
export default compose(
    connect(
        createStructuredSelector({
            subscriptionsLoading: subscriptionInvoicesLoadingSelector,
            subscriptionInvoices: subscriptionInvoicesSelector,
        }),
        { getSubscriptionInvoices, downloadInvoice, clearPending }
    )
)(InvoicesTab)
